var Touchpoint = /* @__PURE__ */ ((Touchpoint2) => {
  Touchpoint2["Unknown"] = "UNKNOWN";
  Touchpoint2["Header"] = "HEADER";
  Touchpoint2["Footer"] = "FOOTER";
  Touchpoint2["ProfileIcon"] = "PROFILE ICON";
  Touchpoint2["Wishlist"] = "WISHLIST ICON";
  Touchpoint2["WishlistPage"] = "WISHLIST PAGE";
  Touchpoint2["FreeDeliveryPdp"] = "FREE DELIVERY PDP";
  Touchpoint2["OrderTracker"] = "ORDER TRACKER";
  Touchpoint2["BehaviouralOverlay"] = "BEHAVIOURAL";
  Touchpoint2["ConfirmedWeb"] = "CONFIRMED WEB";
  Touchpoint2["RegistrationPage"] = "PAGE FORM";
  Touchpoint2["LoginPage"] = "ACCOUNT";
  Touchpoint2["CtaRegistration"] = "STATEMENT CTA";
  Touchpoint2["MembersExclusivePdp"] = "MEMBERS EXCLUSIVE PDP";
  Touchpoint2["MembersExclusivePlp"] = "MEMBERS EXCLUSIVE PLP";
  Touchpoint2["AdidasRunners"] = "ADIDAS RUNNERS";
  Touchpoint2["InviteAFriend"] = "INVITE A FRIEND";
  Touchpoint2["InviteAFriendSenderPage"] = "INVITE A FRIEND SENDER PAGE";
  Touchpoint2["ConfirmedApp"] = "CONFIRMED APP";
  Touchpoint2["APUniversal"] = "AP UNIVERSAL";
  Touchpoint2["Raffles"] = "RAFFLES";
  Touchpoint2["MembershipBarrierPlp"] = "MEMBERSHIP_BARRIER_PLP";
  Touchpoint2["VoucherModal"] = "VOUCHER MODAL";
  Touchpoint2["AdidasApp"] = "ADIDAS APP";
  Touchpoint2["MinicartOverlay"] = "MINICART OVERLAY";
  Touchpoint2["EarlyAccessPdp"] = "EARLY ACCESS PDP";
  Touchpoint2["MembershipBarrierPdp"] = "MEMBERSHIP BARRIER PDP";
  Touchpoint2["MemberPricing"] = "MEMBERS PRICING";
  Touchpoint2["Connect"] = "CONNECT";
  Touchpoint2["ConnectedProduct"] = "CONNECTED PRODUCT";
  Touchpoint2["Campaign"] = "CAMPAIGN";
  Touchpoint2["GET"] = "GET";
  Touchpoint2["CalendarReminder"] = "CALENDAR REMINDER";
  Touchpoint2["Waitlist"] = "WAITINGLIST";
  Touchpoint2["Checkout"] = "CHECKOUT";
  Touchpoint2["Cart"] = "CART";
  Touchpoint2["PartnerLinking"] = "PARTNER LINKING";
  Touchpoint2["AdidasRunningWeb"] = "ADIDAS RUNNING WEB";
  Touchpoint2["AdidasRunningApp"] = "ADIDAS RUNNING APP";
  Touchpoint2["SidePanelGuestMode"] = "SIDE PANEL GUEST MODE";
  return Touchpoint2;
})(Touchpoint || {});
export {
  Touchpoint
};
//# sourceMappingURL=touchpoints.js.map
